/* eslint-disable no-unused-vars */
import React, { memo, useState } from "react";
import { Card,Button,Col,Row,Form,Image,Modal} from "antd";
import { useLocation, useNavigate } from "react-router";
import CustomTable from "../../../components/CustomTable";
import messageToast from "../../../components/messageToast/messageToast";
import apis from "../../../api/stateAPI";

function OrlpcclaimapparmForm() {
  const { state } = useLocation();
  const [form] = Form.useForm();
  const [reason, setReason] = useState("");

  const [showModel, setShowModel] = useState(false);

  const cancelNavigation = () => {
    setShowModel(false);
  };

 
  let url = process.env.REACT_APP_API_BASE_URL;
  url = url.replace("api/", "");
 
  const data =
  state?.expense_data?.length > 0
    ? state.expense_data.map((e) => {        
        let S_No = e.id;
        let Expense_Date = e.expense_date;
        let Expense_Type = e.expense_type;
        let Request_Amount = e.amount;
        let Approved_Amount = e.approved_amount;
        let Reason = e.remark;
        let select = '<input type="checkbox" name="vehicle1" value="Bike">';

        // Ensure bill_copy is processed correctly
        let Bill_Copy = e.bill_copy
          ? e.bill_copy.split(",").map((file) => `${state?.pathfor_attachments}${file.trim()}`)
          : [];      
        return {
          ...e,
          S_No,
          Expense_Date,
          Expense_Type,
          Request_Amount,
          Approved_Amount,
          Reason,
          Bill_Copy,
          select,
        };
      })
    : [];


  const navigate = useNavigate();

  const onClickAdd = () => {
    navigate("/orlpcclaimapparmForm");
  };

  const handleViewClick = (rowInfo) => {
    navigate("/orlpcclaimapparmForm", {
      state: rowInfo,
    });
  };
 
  let column = [
    { key: "1", headerName: "S.No", field: "S.No", hide: false, width: 70 },
    { key: "2", headerName: "Expense Date", field: "Expense_Date",hide: false,width: 150,},
    { key: "3", headerName: "Expense Type", field: "Expense_Type",hide: false,width: 180,},
    { key: "4", headerName: "Reason", field: "Reason",hide: false,width: 250,},
    { key: "5", headerName: "Request Amount", field: "Request_Amount",hide: false,width: 200,},
    { key: "6", headerName: "Approved Amount", field: "Approved_Amount",hide: false,width: 200,},  
   ];
  return (
    <>
      <div className="h-screen apphide lasthide">
        <Card>
          <Row>
            <Col span={24}>
              <Form
                name="basic"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}                          
                autoComplete="off"
              >
                <Row gutter={[15, 0]}>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <CustomTable
          showHeader={false}
          showEdit={false}
          dataSource={data}
          column={column}
          hideActionBtn={true}
          handleViewClick={handleViewClick}
          onClickAdd={onClickAdd}
          title={"Approval List"}
        />        
      </div>    
    </>
  );
}

export default memo(OrlpcclaimapparmForm);

